// Globale Variable für die aktuell aktive Gruppe
let currentActiveGroup = null;

document.addEventListener("DOMContentLoaded", function() {
  const track = document.getElementById('main-track');
  
  // 1. Alle Slides aus den Templates in den Haupt-Track verschieben
  document.querySelectorAll('template[data-target="main-track"]').forEach(template => {
    const clone = template.content.cloneNode(true);
    const group = clone.querySelector('.theme-content-group');

    if (group) {
      group.dataset.autoplay = template.dataset.autoplay;
      group.dataset.speed = template.dataset.speed;
    }

    track.appendChild(clone);
  });

  // 2. Erstes Thema aktivieren
  const firstThumb = document.querySelector('.thumbnail-item');
  if(firstThumb) firstThumb.click();
});

let autoplayInterval = null;

function switchTheme(themeId, element) {
  // Alle Thumbnails deaktivieren
  document.querySelectorAll('.thumbnail-item').forEach(t => t.classList.remove('active'));
  element.classList.add('active');

  // Alle Themen-Gruppen im Slider verstecken
  document.querySelectorAll('.theme-content-group').forEach(group => {
    group.style.display = 'none';
  });

  // Nur die gewählte Gruppe zeigen
  const activeGroup = document.getElementById(themeId);
  if(activeGroup) {
    activeGroup.style.display = 'flex'; // Wieder sichtbar machen
    
    // Gruppe als global aktiv setzen und zum 1. Slide springen (Reset)
    currentActiveGroup = activeGroup;
    currentActiveGroup.scrollLeft = 0; 

    // Dots für die aktuelle Gruppe generieren
    createDots(activeGroup);

    // Autoplay für die ausgewählte Gruppe starten
    initAutoplayForGroup(activeGroup);
  }
}

function createDots(group) {
  const dotsContainer = document.getElementById('slideshow-dots');
  if (!dotsContainer) return;

  dotsContainer.innerHTML = ''; // Vorherige Dots löschen

  // Finde alle Slides (Shopify Blöcke) innerhalb der Gruppe
  const slides = group.querySelectorAll('.shopify-block');

  // Wenn 1 oder weniger Slides da sind, abgebrochen (keine Dots rendern)
  if (slides.length <= 1) {
    return;
  }

  slides.forEach((_, index) => {
    const dot = document.createElement('span');
    dot.classList.add('dot');
    if (index === 0) dot.classList.add('active');

    dot.addEventListener('click', () => {
      const slideWidth = group.offsetWidth;
      group.scrollTo({ left: index * slideWidth, behavior: 'smooth' });
    });

    dotsContainer.appendChild(dot);
  });

  // Scroll-Event nur hinzufügen, wenn es mehr als 1 Slide gibt
  group.addEventListener('scroll', () => {
    const index = Math.round(group.scrollLeft / group.offsetWidth);
    updateActiveDot(index);
  });
}

function updateActiveDot(index) {
  const dots = document.querySelectorAll('.dot');
  dots.forEach((dot, i) => {
    dot.classList.toggle('active', i === index);
  });
}

function initAutoplayForGroup(group) {
  stopAutoplay(); // Altes Intervall löschen

  const isEnabled = group.dataset.autoplay === 'true';
  const speed = parseInt(group.dataset.speed) || 5000;

  if (!isEnabled) return;

  autoplayInterval = setInterval(() => {
    const slides = group.querySelectorAll('.main-slide');
    const currentIndex = Math.round(group.scrollLeft / group.offsetWidth);
    
    if (currentIndex < slides.length - 1) {
      moveSlide(1);
    } else {
      group.scrollTo({ left: 0, behavior: 'smooth' });
    }
  }, speed);
}

function stopAutoplay() {
  if (autoplayInterval) clearInterval(autoplayInterval);
}

// Pfeil-Navigation
function moveSlide(direction) {
  if (!currentActiveGroup) return;

  const slideWidth = currentActiveGroup.offsetWidth;
  // Berechne das neue Scroll-Ziel basierend auf der aktuellen Position + Breite
  const newScrollLeft = currentActiveGroup.scrollLeft + (direction * slideWidth);
  
  // Scrolle die Gruppe smooth an die neue Position
  currentActiveGroup.scrollTo({
    left: newScrollLeft,
    behavior: 'smooth'
  });
}

function updateThumbNav() {
  const sidebar = document.getElementById('thumb-sidebar');
  const prevBtn = document.getElementById('thumb-prev');
  const nextBtn = document.getElementById('thumb-next');
  
  if (!sidebar) return;

  const isDesktop = window.innerWidth >= 990;
  let hasOverflow = false;

  // Math.ceil/floor hilft gegen Subpixel-Rundungsfehler auf Mobile-Displays
  if (isDesktop) {
    // Vertikaler Overflow (Toleranz von 1px)
    hasOverflow = Math.ceil(sidebar.scrollHeight) - Math.ceil(sidebar.clientHeight) > 1;
  } else {
    // Horizontaler Overflow (Toleranz von 1px)
    hasOverflow = Math.ceil(sidebar.scrollWidth) - Math.ceil(sidebar.clientWidth) > 1;
  }

  // Pfeile flex/block oder none schalten
  const displayStyle = hasOverflow ? 'flex' : 'none';
  if (prevBtn) prevBtn.style.display = displayStyle;
  if (nextBtn) nextBtn.style.display = displayStyle;
}

// 1. Sobald alle Bilder fertig geladen sind (Ganz wichtig für Mobile!)
window.addEventListener('load', updateThumbNav);

// 2. Bei Resize
window.addEventListener('resize', updateThumbNav);

// 3. Für Shopify Theme Editor Events
document.addEventListener('shopify:block:select', updateThumbNav);
document.addEventListener('shopify:section:load', updateThumbNav);

function moveThumbs(direction) {
  const sidebar = document.getElementById('thumb-sidebar');
  const isDesktop = window.innerWidth >= 990;
  const scrollAmount = 150; // Pixel pro Klick

  if (isDesktop) {
    sidebar.scrollBy({ top: direction * scrollAmount, behavior: 'smooth' });
  } else {
    sidebar.scrollBy({ left: direction * scrollAmount, behavior: 'smooth' });
  }
}

// Initialisierung & Events
window.addEventListener('resize', updateThumbNav);
document.addEventListener('DOMContentLoaded', () => {
  // Kurz warten, damit Bilder laden und die Höhe korrekt berechnet wird
  setTimeout(updateThumbNav, 500);
});

// Da Shopify Blöcke dynamisch hinzufügt, auch im Editor triggern
document.addEventListener('shopify:block:select', updateThumbNav);
document.addEventListener('shopify:section:load', updateThumbNav);